<div>
    <div class="table-responsive settings-table-shell settings-reference-table rounded-4 border">
        <table
            class="table table-hover align-middle mb-0 settings-data-table global_data_table text-xs"
            data-search-placeholder="Search properties"
            data-non-orderable-targets="[6]"
            data-page-length="5"
            data-order-column="0"
            data-order-direction="asc"
        >
            <thead>
                <tr>
                    <th scope="col" class="settings-table-head fw-semibold text-xs">Property</th>
                    <th scope="col" class="settings-table-head fw-semibold text-xs">Tariff name</th>
                    <th scope="col" class="settings-table-head fw-semibold text-xs">Tariff book</th>
                    <th scope="col" class="settings-table-head fw-semibold text-xs">Code</th>
                    <th scope="col" class="settings-table-head fw-semibold text-xs">Tariff category</th>
                    <th scope="col" class="settings-table-head fw-semibold text-xs">Effective dates</th>
                    <th scope="col" class="settings-table-head fw-semibold text-xs text-end">Actions</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="row in tariff_rows" :key="row.id">
                    <td>
                        <span class="fw-semibold text-xs lh-sm">{{ row.property_name }}</span>
                    </td>
                    <td>
                        <span class="fw-semibold text-xs">{{ row.has_assignment ? row.tariff_name : "-" }}</span>
                    </td>
                    <td>
                        <span class="fw-semibold text-xs">{{ row.has_assignment ? row.tariff_book_name : "-" }}</span>
                    </td>
                    <td class="fw-semibold text-xs">{{ row.has_assignment ? row.tariff_code : "-" }}</td>
                    <td>
                        <span class="badge rounded-pill settings-soft-badge settings-soft-badge-pink text-xs">
                            {{ row.has_assignment ? row.tariff_category : "-" }}
                        </span>
                    </td>
                    <td>
                        <span class="fw-semibold text-xs lh-sm">
                            {{ row.rate_effective_from || row.effective_from ? get_assignment_date_range(row) : "-" }}
                        </span>
                    </td>
                    <td>
                        <div class="d-flex justify-content-end gap-2 flex-wrap">
                            <button
                                type="button"
                                class="btn btn-primary btn-sm rounded-3 d-inline-flex align-items-center px-3 shadow-sm"
                                @click="$emit('edit-assignment', row)"
                                :aria-label="row.has_assignment ? 'Unassign tariff' : 'Assign tariff'"
                            >
                                <span class="text-xs">{{ row.has_assignment ? "Unassign" : "Assign" }}</span>
                            </button>
                        </div>
                    </td>
                </tr>

                <tr v-if="!tariff_rows.length">
                    <td colspan="7" class="text-center py-4 text-xs">
                        <div class="d-flex flex-column align-items-center justify-content-center py-4">
                            <span class="d-inline-flex align-items-center justify-content-center rounded-circle border bg-light text-dark mb-3" style="width: 2.5rem; height: 2.5rem;">
                                <i class="bi bi-building"></i>
                            </span>
                            <p class="fw-semibold mb-1">No properties available</p>
                            <p class="text-xs mb-0">Properties and assigned tariff books will appear here once loaded.</p>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
